var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMaestroLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), "s", _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#0a1329",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7375cf",
  d: "M19.39 6.5h-6.13v11h6.13z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#eb001b",
  d: "M13.65 12a6.99 6.99 0 0 1 2.68-5.5 7 7 0 1 0 0 11 6.99 6.99 0 0 1-2.68-5.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#00a2e5",
  d: "M26.98 16.34v-.23h.1v-.04h-.24v.04h.1v.23zm.45 0v-.27h-.07l-.08.18-.08-.18h-.07v.27h.05v-.2l.07.17h.06l.07-.18v.2h.05Zm.22-4.34a7 7 0 0 1-11.32 5.5 7 7 0 0 0 0-11A7 7 0 0 1 27.65 12"
})));
export default SvgMaestroLight;